<script setup lang="ts">
  import { computed, onMounted, ref } from 'vue'
  import {
    useApiRequestsAbort,
    useGoogleAnalytics,
    usePerformanceTiming,
  } from '@/shared/composables'
  import { useCommonStore } from '@/shared/store'
  import { TravelDirection } from '@/shared/types/common.types'
  import { AnalyticsPageName } from '@/shared/constants/analytics.constants'
  import { useFormDataWithRedirect } from '@/shared/composables/useFormDataWithRedirect'
  import { FlowPersonalInformationWidgetQC } from '@/widgets/Flow'

  const emit = defineEmits<Emits>()

  interface Emits {
    (e: 'load', request: () => Promise<any>, requestId?: string, withLoader?: boolean): void
  }
  useApiRequestsAbort()

  const { getFormData } = useFormDataWithRedirect()
  const commonStore = useCommonStore()
  const { onPerformanceCheckEnd } = usePerformanceTiming()
  const gaService = useGoogleAnalytics()

  const winterSportPrice = ref(0)
  const loadingFormData = ref(true)
  const nationalities = computed(() => commonStore.nationalities)

  const fetchNationalities = async () => {
    if (nationalities.value.length > 0) return

    const data = await commonStore.findNationalities()
    commonStore.setNationalities(data)
  }

  onMounted(() => {
    emit(
      'load',
      async () => {
        if (!(await getFormData(TravelDirection.OUTBOUND, true, true))) return
        loadingFormData.value = false
        await fetchNationalities()

        onPerformanceCheckEnd()
        gaService.sendViewPage(TravelDirection.OUTBOUND, AnalyticsPageName.HOLDER_INFO)
      },
      'getNationalities'
    )
  })
</script>

<template>
  <FlowPersonalInformationWidgetQC
    :with-winter-sport="false"
    :winter-sport-price="winterSportPrice"
    :loading-form-data="loadingFormData"
    @load="emit('load', $event, 'sendFormData', false)"
  />
</template>
